import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleBack = () => {
    navigate(-1);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-blue-600 text-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center space-x-8">
            <Link to="/dashboard" className="flex items-center">
              <img src="/logo.png" alt="ZoomPay" style={{height: "40px", width: "auto"}} />
            </Link>
            
            <div className="hidden md:flex space-x-4">
              <Link
                to="/dashboard"
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  isActive('/dashboard')
                    ? 'bg-blue-700'
                    : 'hover:bg-blue-500'
                }`}
              >
                Dashboard
              </Link>
              
              <Link
                to="/send"
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  isActive('/send')
                    ? 'bg-blue-700'
                    : 'hover:bg-blue-500'
                }`}
              >
                Send Money
              </Link>
              
              {/* ← NEW: Recipients Link */}
              <Link
                to="/recipients"
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  isActive('/recipients')
                    ? 'bg-blue-700'
                    : 'hover:bg-blue-500'
                }`}
              >
                👥 Recipients
              </Link>
              
              <Link
                to="/profile"
                className={`px-3 py-2 rounded-md text-sm font-medium ${
                  isActive('/profile')
                    ? 'bg-blue-700'
                    : 'hover:bg-blue-500'
                }`}
              >
                Profile
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-3">
            <button
              onClick={handleBack}
              className="px-4 py-2 rounded-md text-sm font-medium bg-gray-700 hover:bg-gray-600 transition"
            >
              ← Back
            </button>
            
            <button
              onClick={handleLogout}
              className="px-4 py-2 rounded-md text-sm font-medium bg-red-600 hover:bg-red-700 transition"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;